import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setPageTabData } from '../../../../redux/slices/dynamicUiSlice'
import TabGroup from '../../../../components/tab/TabGroup'
import { CustomTabRef } from '../../../../components/tab/CustomTab'
import CustomIcon from '../../../../components/CustomIcon'
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu'
import PageStickyTabItem from './PageStickyTabItem'

const PageStickyTabs = () => {

  const loading = useSelector((state) => state.dynamicElements.editing.loading)

  const selectedGroup = useSelector((state) => state.dynamicUi.pages.selectedGroup)
  const selectedPage = useSelector((state) => state.dynamicUi.pages.selectedPage)
  const isVertical = useSelector((state) => state.dynamicUi.pages[selectedGroup].data[selectedPage]?.is_vertical)

  const tabItems = useSelector((state) => state.dynamicUi.pages.tabs.data)
  const activeTab = useSelector((state) => state.dynamicUi.pages.tabs.selected)
  const dropDownItems = useSelector((state) => state.dynamicUi.pages.tabs.dropdowns)


  const dispatch = useDispatch()

  const updateTab = (tab, fromDropDown = false) => {
    if (tab.id !== activeTab && !loading) {

      dispatch(setPageTabData({ selected: tab, fromDropDown }))

    }
  }

  return (<>
      {tabItems && tabItems.length > 1 &&

        <TabGroup inline={false} scroll={isVertical} showNav={tabItems.length > 9}>
          {tabItems.map((tab, i) => <PageStickyTabItem updateTab={updateTab } activeTab={activeTab} key={tab.id} tab={tab} />)}
          {!isVertical && !!dropDownItems.length &&
            <DropdownMenu placement="bottom-end" shouldFlip isLoading={loading} isDisabled={loading}
                          trigger={({ triggerRef, isSelected, testId, ...props }) => (
                            <CustomTabRef ref={triggerRef} {...props} active={isSelected}
                                          className="flex items-center px-3">
                              <CustomIcon icon="more_horiz" size="xl"
                                          className="cursor-pointer leading-7" />
                            </CustomTabRef>)}
            >
              <DropdownItemGroup>
                {dropDownItems.map((item, i) => <DropdownItem key={`${item.id}${i}`}
                                                              onClick={() => updateTab(item, true)}>
                  {item.title ?? item.value}
                </DropdownItem>)}

              </DropdownItemGroup>
            </DropdownMenu>}

        </TabGroup>}
    </>)
}

export default React.memo(PageStickyTabs)



